import React from "react";

import Radio from "./Radio";
import { Form } from "react-bootstrap";

import getIndex from "../utils/getIndex";
import newid from "../utils/newid";
import basePath from "../utils/basePath";

class BuildAvatar extends React.Component {
  state = {
    gear: 0,
    outfit: 0,
    accessories: 0,
    scenery: 0,
    name: "You",
    validated: false,
    size: "medium",
  };
  initialState = { ...this.state };
  currentMember = this.props.globalState.family.filter((value) => {
    return value.id === this.props.globalState.editId;
  })[0];
  currentId = "";
  displayNames = {
    gear: "Head",
    outfit: "Outfit",
    accessories: "Accessories",
    scenery: "Location",
  };
  componentDidMount = () => {
    const defaults = {
      gear: this.getDefault("gear"),
      outfit: this.getDefault("outfit"),
      accessories: this.getDefault("accessories"),
      scenery: this.getDefault("scenery"),
      name: this.getDefault("name"),
      size: this.getDefault("size"),
    };
    this.setState(defaults);
  };
  getDefault = (prop) => {
    if (this.currentMember) {
      if (prop === "name" || prop === "size") {
        return this.currentMember[prop];
      }
      return getIndex(this.props.globalState.avatarOptions[this.currentMember.size][prop], "name", this.currentMember[prop].name);
    }
    return this.initialState[prop];
  };
  handleInput = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      document.querySelector("input:invalid").focus();
      this.setState({ validated: true });
    } else {
      this.props.updateMember(this.buildMember());
      this.props.goTo("Results");
    }
    event.preventDefault();
  };
  handleNext = (part) => {
    let totalItems = this.props.globalState.avatarOptions[this.state.size][part].length,
      newValue = this.state[part] + 1;
    if (newValue > totalItems - 1) {
      newValue = 1;
    }
    this.setState({ [part]: newValue });
  };
  handlePrev = (part) => {
    let totalItems = this.props.globalState.avatarOptions[this.state.size][part].length,
      newValue = this.state[part] - 1;
    if (newValue < 1) {
      newValue = totalItems - 1;
    }
    this.setState({ [part]: newValue });
  };
  buildMember = () => {
    this.currentId = this.props.globalState.editId || newid("fam");
    const newMember = {
      name: this.state.name,
      size: this.state.size,
      id: this.currentId,
    };
    newMember.gear = this.props.globalState.avatarOptions[this.state.size]["gear"][this.state.gear];
    newMember.scenery = this.props.globalState.avatarOptions[this.state.size]["scenery"][this.state.scenery];
    newMember.outfit = this.props.globalState.avatarOptions[this.state.size]["outfit"][this.state.outfit];
    newMember.accessories = this.props.globalState.avatarOptions[this.state.size]["accessories"][this.state.accessories];
    return newMember;
  };
  doneHelper = () => {
    let doneHTML = (
      <button type="submit" className="btn btn-primary">
        next
      </button>
    );
    if (this.state.accessories === 0 || this.state.outfit === 0 || this.state.gear === 0 || this.state.scenery === 0) {
      doneHTML = (
        <button disabled="disabled" type="submit" className="btn btn-primary">
          customize to continue
        </button>
      );
    }
    return doneHTML;
  };
  cancelHelper = () => {
    if (this.currentMember) {
      return (
        <>
          <br />
          <a href="#" className="inline-link" onClick={() => this.props.goTo("Results")}>
            cancel edit
          </a>
        </>
      );
    }
    return null;
  };
  partBuilder = (part) => {
    let newImg = (
      <img
        src={`${basePath}images/parts/${this.props.globalState.avatarOptions[this.state.size][part][this.state[part]]["file"]}`}
        alt={`Current ${part} is ${this.props.globalState.avatarOptions[this.state.size][part][this.state[part]]["name"]}`}
        aria-live="polite"
      />
    );
    return (
      <>
        <div className={`part ${part} ${this.state.size}`}>{newImg}</div>
        <button type="button" className={`builder-btn btn-prev builder-btn-${part}`} onClick={() => this.handlePrev(part)}>
          <span className="part-label" aria-hidden="true">
            <span className="part-label-inner">{this.displayNames[part]}</span>
          </span>
          <span className="sr-only">Previous {this.displayNames[part]}</span>
          <span className="arw"></span>
        </button>
        <button type="button" className={`builder-btn btn-next builder-btn-${part}`} onClick={() => this.handleNext(part)}>
          <span className="part-label" aria-hidden="true">
            {this.displayNames[part]}
          </span>
          <span className="sr-only">Next {this.displayNames[part]}</span>
          <span className="arw"></span>
        </button>
      </>
    );
  };
  render() {
    return (
      <div className="build-avatar">
        <section>
          <div className="container">
            <Form onSubmit={this.handleSubmit} noValidate validated={this.state.validated}>
              <div className="row align-items-center">
                <div className="col-5 text-right col-xs-5 px-3 py-5">
                  <h1 className="small">
                    <span className="leftblock">
                      HOW
                      <br />
                      DID
                      <br />
                      YOU
                    </span>
                    <span className="rightblock">
                      <em>20</em>
                      <br />
                      <em>20</em>?
                    </span>
                  </h1>
                </div>
                <div className="col-md-4 col-7 col-xs-7 px-3 py-5">
                  <p className="my-0">
                    Using the arrows, select your 2020 head, outfit, accessories and location that best describes YOU this past year and your methods for
                    getting through the madness.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col text-center">
                  <p className="border-separator">
                    <strong className="grey-rule">
                      BASE <span class="sr-only">skin color</span>
                    </strong>
                  </p>
                  <Radio
                    name="size"
                    value={this.state.size}
                    change={this.handleInput}
                    required={true}
                    className="age-radio"
                    options={["lightest", "light", "medium", "dark", "darkest"]}
                    label={["lightest", "light", "medium", "dark", "darkest"]}
                    feedback="You must select before submitting"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="avatar">
                    {this.partBuilder("gear")}
                    {this.partBuilder("outfit")}
                    {this.partBuilder("accessories")}
                    {this.partBuilder("scenery")}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col text-center actions">
                  {this.doneHelper()}
                  {this.cancelHelper()}
                </div>
              </div>
            </Form>
          </div>
        </section>
      </div>
    );
  }
}
export default BuildAvatar;
